import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Output } from '@angular/core';
import {
  DsButtonV2Component,
  DsCardComponent,
  DsIconComponent,
  DsTagPillComponent,
} from '@customdesignsystem';

/**
 * Hero del paso 0 — Solicitud de Pensión por Invalidez.
 * Maqueta alineada al diseño (gradiente, barra de estado y CTA).
 */
@Component({
  selector: 'app-pi-hero-card',
  standalone: true,
  imports: [
    CommonModule,
    DsCardComponent,
    DsIconComponent,
    DsTagPillComponent,
    DsButtonV2Component,
  ],
  templateUrl: './pi-hero-card.component.html',
  styleUrls: ['./pi-hero-card.component.scss'],
})
export class PiHeroCardComponent {
  /** Gradiente Greeting — Figma */
  readonly heroBackground = 'linear-gradient(114.9deg, #061728 8.34%, #2e67a3 95.44%)';

  @Output() queEsPension = new EventEmitter<void>();
  @Output() revisaPasos = new EventEmitter<void>();
}
